import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import { FormResponse } from "../forms/form.dto";
import {
  CreateForumDto,
  CreateMessageDto,
  ForumWithMessagesDTO,
  ForumWithoutMessage,
  ToggleVisibilityDto
} from "./forum.dto";

const services = {
  CreateNewForm(dto: CreateForumDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forum/create", dto, config);
  },
  CreateNewMessage(dto: CreateMessageDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forum/create-m", dto, config);
  },
  GetForumByTopic(topic: string, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ForumWithoutMessage[]>(`forum/${topic}/`, config);
  },
  GetForumById(idForum: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ForumWithMessagesDTO>(`forum/id/${idForum}/`, config);
  },
  ToggleVisibility(
    idForum: number,
    toggleVisibilityDto: ToggleVisibilityDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<ToggleVisibilityDto>(`forum/toggle-visibility/${idForum}/`, toggleVisibilityDto, config);
  },
  ToggleMessageVisibility(
    idMessage: number,
    messageVisibilityDto: ToggleVisibilityDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<ToggleVisibilityDto>(`forum/toggle-message-visibility/${idMessage}/`, messageVisibilityDto, config);
  }
};

export default services;
